module.exports = __webpack_public_path__ + "static/media/bettr-home.5396ec1d.png";